import Calculator from '@uvocore-front/calculator';
import { observeElement } from '@uvocore-front/utils';
import './style.scss';
import getDefaultCalcOptions from '../getDefaultCalcOptions';

const defaultConfigs = getDefaultCalcOptions();

const OPTIONS = {
  container: '.CalculatorStem',
  defaultConfigs,
  layout: {
    name: 'big',
    version: 1,
    components: {
      OrderButton: {
        text: 'SUBMIT ORDER',
      },
    },
  },
  theme: {
    colors: {
      backgroundColor: '#FFF',
      primaryColor: '#000',
      secondaryColor: '#000',
      spinnerRgbColor: '0 0 0',
    },
    typography: {
      baseFontFamily: 'DM Sans',
      baseBorderRadius: 0,
    },
    components: {
      LayoutForm: {
        border: '3px solid #000',
        boxShadow: 'none',
      },
      LayoutComponentsWrapper: {
        label: {
          '@media (min-width: 768px)': {
            fontSize: 14,
          },
          '@media (min-width: 1024px)': {
            fontSize: 16,
          },
          '@media (min-width: 1366px)': {
            fontSize: 20,
          },
        },
      },
      OrderServiceType: {
        button: {
          '@media (min-width: 768px)': {
            fontSize: 26,
          },
          fontWeight: 500,
          border: '3px solid #000',
          borderWidth: '0 3px 3px 0',
          '&:last-child': {
            borderWidth: '0 0 3px 0',
          },
          '& svg path': {
            stroke: '#000 !important',
          },
          active: {
            backgroundColor: '#FAFF00',
          },
          hover: {
            backgroundColor: '#F2F2F2',
          },
        },
      },
      UISelect: {
        select: {
          height: 'auto',
          padding: '16px 45px 14px 17px',
          boxShadow: 'none',
          border: '3px solid #000',
          fontWeight: 500,
          '@media (min-width: 768px)': {
            fontSize: 14,
            height: 'auto',
            padding: '16px 25px 16px 17px',
          },
          '@media (min-width: 1024px)': {
            fontSize: 18,
          },
          '@media (min-width: 1366px)': {
            fontSize: 24,
          },
        },
      },
      TaskSize: {
        '& > div:first-of-type': {
          border: '3px solid #000',
          '@media (min-width: 768px)': {
            border: '3px solid #000',
          },
          ' button': {
            padding: '16px 5px',
          },
          ' button:not(:last-child)': {
            borderRight: '3px solid #000',
          },
        },
        '& > div:last-of-type': {
          boxShadow: 'none',
          border: '3px solid #000',
          borderTopWidth: 0,
        },
        '@media (min-width: 1366px)': {
          maxWidth: 'none',
        },
      },
      TaskSizeInfo: {
        '@media (min-width: 768px)': {
          border: '3px solid #000',
          borderTopWidth: 0,
        },
        '@media (min-width: 1024px)': {
          border: 'none',
          boxShadow: 'rgb(0 0 0) 0px 0px 0px 3px inset',
        },
        '& > div:first-child': {
          '@media (min-width: 1024px)': {
            color: '#0013BC',
            fontSize: 16,
          },
        },
        example: {
          '@media (min-width: 1024px)': {
            backgroundColor: '#F2F2F2',
          },
        },
      },
      UIButton: {
        '@media (min-width: 768px)': {
          fontSize: 14,
        },
        '@media (min-width: 1024px)': {
          fontSize: 18,
        },
        '@media (min-width: 1366px)': {
          fontSize: 24,
        },
        fontWeight: 500,
        active: {
          backgroundColor: '#FAFF00',
          color: '#000',
        },
        hover: {
          backgroundColor: '#F2F2F2',
          color: '#000',
        },
      },
      Deadlines: {
        deadlineMobileTrigger: {
          boxShadow: '#000 0px 0px 0px 3px inset',
        },
        buttons: {
          gridColumnGap: 0,
          '@media (min-width: 1140px)': {
            gridColumnGap: 0,
          },
          button: {
            boxShadow: 'none',
            border: '3px solid #000',
            '@media (min-width: 768px)': {
              borderWidth: '3px 3px 3px 0',
              '&:first-child': {
                borderWidth: 3,
              },
              'strong::after': {
                fontSize: 14,
              },
            },
          },
        },
        button: {
          active: {
            backgroundColor: '#FAFF00',
            borderWidth: 0,
          },
          hover: {
            backgroundColor: '#F2F2F2',
          },
          span: {
            boxShadow: '#fff 0px 0px 0px 4px, #000 0px 0px 0px 5px',
          },
          '&.UIButton--active span': {
            boxShadow: '0 0 0 3px #FAFF00, 0 0 0 5px black !important',
          },
          strong: {
            '@media (min-width: 1024px)': {
              fontSize: 28,
            },
          },
        },
        bigDeadlineDate: {
          '@media (min-width: 768px)': {
            gridArea: '3 / auto / auto',
            textAlign: 'center',
            minHeight: 50,
          },
        },
        bigDeadlineButton: {
          active: {
            span: {
              backgroundColor: '#FAFF00',
            },
          },
        },
      },
      DeadlineInfo: {
        color: '#000',
        marginTop: 20,
        '@media (min-width: 1366px)': {
          fontSize: 18,
          marginTop: 26,
        },
      },
      TotalPrice: {
        approximatePrice: {
          flexDirection: 'column',
          fontWeight: 500,
          '@media (min-width: 768px)': {
            alignItems: 'flex-start',
            margin: '0 16px 0 0',
          },
          '@media (min-width: 1024px)': {
            fontSize: 18,
          },
          '@media (min-width: 1366px)': {
            fontSize: 22,
            margin: '0 35px 0 0',
          },
          strong: {
            marginLeft: 0,
            '@media (min-width: 1024px)': {
              fontSize: 34,
            },
            '@media (min-width: 1366px)': {
              fontSize: 40,
            },
          },
        },
      },
      OrderButton: {
        fontStyle: 'italic',
        backgroundColor: '#0013BC',
        textAlign: 'center',
        border: '3px solid #000',
        fontSize: 30,
        alignSelf: 'stretch',
        minWidth: 300,
        padding: '11px 44px 12px',
        '@media (min-width: 768px)': {
          padding: '25px 38px',
        },
        '@media (min-width: 1366px)': {
          fontSize: 36,
        },
        hover: {
          backgroundColor: '#000',
          color: '#fff',
        },
      },
    },
  },
};

observeElement({
  element: '.CalculatorStem',
  marginValue: 300,
  callback: () => {
    Calculator.init(OPTIONS);
  },
});
